import { useMutation } from '@apollo/client';
import { RequestBooking } from '../../shared/types';
import { CITRIN_CREATE_REQUEST_BOOKING, CreateRequestBookingRequest, CreateRequestBookingResponse } from '..';

type CreateMutationFunction = (request: RequestBooking) => Promise<RequestBooking>;
export const useCreateRequestBookingMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateRequestBookingResponse, CreateRequestBookingRequest>(
        CITRIN_CREATE_REQUEST_BOOKING
    );

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createRequestBooking;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
